import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana108Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
    <rect width="1221" height="921" fill="url(#pattern0_1339_2522)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M618.669 479.231L666.881 448.035L625.759 378.553C609.877 383.09 582.273 401.241 570.457 409.749L618.669 479.231Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M533.582 440.946C542.657 428.468 561.469 415.422 570.45 409.75L618.662 479.232C609.586 492.845 583.684 513.264 571.868 521.772L533.582 440.946Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M520.82 555.805C537.836 548.999 561.943 530.281 571.869 521.773L533.582 440.947C519.97 453.426 501.441 465.999 493.878 470.725L520.82 555.805Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M461.268 578.491C481.687 575.088 509.48 561.947 520.824 555.803L493.882 470.723L448.506 490.575L461.268 578.491Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M398.873 500.502C415.889 499.368 439.049 493.412 448.503 490.576L461.265 578.492C435.173 586.433 408.799 588.891 398.873 588.418V500.502Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M349.25 499.084C369.67 500.218 390.845 500.502 398.88 500.502V588.418C365.983 590.687 343.578 587.473 336.488 585.582L349.25 499.084Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M306.704 487.738C323.72 493.41 342.154 497.664 349.244 499.082L336.482 585.58C316.063 577.64 276.926 554.857 259.91 544.458C270.119 525.174 295.36 498.61 306.704 487.738Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1339_2522" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1339_2522" transform="matrix(0.00194503 0 0 0.00257858 -4.86221 -2.69808)"/>
    </pattern>
    <image id="image0_1339_2522" width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};